import React, { useMemo } from 'react';
import Markdown, { MarkdownToJSX } from 'markdown-to-jsx';

import { toInlineMarkdown } from 'src/utils/markdownText';

// No autolinking: previews sit inside card links, so bare URLs/emails stay text.
const INLINE_OPTIONS: MarkdownToJSX.Options = {
  forceInline: true,
  disableAutoLink: true,
};

interface MarkdownInlineProps {
  markdown: string | null | undefined;
}

/**
 * Markdown preview for clamped one-paragraph slots (e.g. blog cards): renders
 * inline formatting only, so it can sit inside a <p> or a link.
 */
const MarkdownInline: React.FC<MarkdownInlineProps> = ({ markdown }) => {
  const inline = useMemo(() => toInlineMarkdown(markdown ?? ''), [markdown]);

  if (!inline) return null;

  return <Markdown options={INLINE_OPTIONS}>{inline}</Markdown>;
};

export default MarkdownInline;
